/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$Z as $Z,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_TarjetaBot as TarjetaBot,
  rec_api as api,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function EstadoBots() {
  let e = (0, ReactCompiler.c)(20),
    [t, n] = (0, React.useState)(null),
    [r, i] = (0, React.useState)(``),
    a;
  e[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((a = async () => {
        try {
          (n(
            await api(`/bots`, {
              sinCache: !0,
            }),
          ),
            i(``));
        } catch (e) {
          i(e.message);
        }
      }),
      (e[0] = a))
    : (a = e[0]);
  let o = a,
    s,
    c;
  (e[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((s = () => {
        o();
      }),
      (c = [o]),
      (e[1] = s),
      (e[2] = c))
    : ((s = e[1]), (c = e[2])),
    (0, React.useEffect)(s, c));
  let l, u;
  if (
    (e[3] !== t || e[4] !== r
      ? ((l = () => {
          if (!t && !r) return;
          let e = setTimeout(o, $Z(t));
          return () => clearTimeout(e);
        }),
        (u = [t, r, o]),
        (e[3] = t),
        (e[4] = r),
        (e[5] = l),
        (e[6] = u))
      : ((l = e[5]), (u = e[6])),
    (0, React.useEffect)(l, u),
    !t)
  ) {
    let t;
    return (
      e[7] === r
        ? (t = e[8])
        : ((t = r ? (
            <EstadoError mensaje={r} onReintentar={o} />
          ) : (
            <div
              className={`flex justify-center py-16 text-(--text)`}
              children={(0, JSXRuntime.jsx)(ii, {
                className: `h-6 w-6 animate-spin`,
              })}
            />
          )),
          (e[7] = r),
          (e[8] = t)),
      t
    );
  }
  let f;
  e[9] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((f = (
        <p
          className={`text-sm text-(--text)`}
          children={`Cada bot atiende desde su propio número. Para conectarlo, se escanea el código con el teléfono de ese número.`}
        />
      )),
      (e[9] = f))
    : (f = e[9]);
  let p;
  e[10] === r
    ? (p = e[11])
    : ((p = r && (
        <p
          role={`alert`}
          className={`rounded-xl border border-(--warning-border) bg-(--warning-bg) px-3 py-2 text-xs text-(--warning-texto)`}
          children={`No se pudo actualizar: lo de abajo es de hace unos segundos.`}
        />
      )),
      (e[10] = r),
      (e[11] = p));
  let m;
  if (e[12] !== t) {
    let n;
    (e[14] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((n = (e) => <TarjetaBot key={e.id} bot={e} onCambio={o} />),
        (e[14] = n))
      : (n = e[14]),
      (m = t.map(n)),
      (e[12] = t),
      (e[13] = m));
  } else m = e[13];
  let h;
  e[15] === m
    ? (h = e[16])
    : ((h = (
        <div className={`grid items-start gap-4 md:grid-cols-2`} children={m} />
      )),
      (e[15] = m),
      (e[16] = h));
  let _;
  return (
    e[17] !== p || e[18] !== h
      ? ((_ = (
          <div
            className={`mx-auto flex w-full max-w-5xl flex-col gap-4`}
            children={[f, p, h]}
          />
        )),
        (e[17] = p),
        (e[18] = h),
        (e[19] = _))
      : (_ = e[19]),
    _
  );
}
